import {BaseTileProvider} from './base-tile-provider';
import {environment} from '../../../../environments/environment';
import {MapType} from '../../enums/map-type';
import {sprintf} from 'sprintf-js';
import {MapProvider} from '../../enums/map-provider.enum';
import {SettingsService} from '../../services/settings.service';

export class OpenCycleMapTileProvider extends BaseTileProvider {

  // From the environment files (not in git); the browser sends it with every tile.
  private static API_KEY = environment.thunderforestApiKey || '';
  private static URL_OPEN_CYCLE_MAP = `https://tile.thunderforest.com/cycle/{z}/{x}/{y}.png?apikey=${this.API_KEY}`; // servers: [abc].tile...
  private static URL_OPEN_CYCLE_MAP2 = `https://tile.thunderforest.com/transport/{z}/{x}/{y}.png?apikey=${this.API_KEY}`; // servers: [abc].tile...
  private static URL_OPEN_CYCLE_MAP3 = `https://tile.thunderforest.com/landscape/{z}/{x}/{y}.png?apikey=${this.API_KEY}`; // servers: [abc].tile...
  private static URL_OPEN_CYCLE_MAP4 = `https://tile.thunderforest.com/outdoors/{z}/{x}/{y}.png?apikey=${this.API_KEY}`; // servers: [abc].tile...

  getMapProvider(): string {
    return MapProvider.OPEN_CYCLE_MAP;
  }

  getMaxZoom(): number {
    return 19;
  }

  getUrlTemplate(mapType?: MapType): string {let mt = mapType;
    if(!mt){
      mt = SettingsService.settings.mapType;
    }
    let url = '';
    switch (mt) {
      case MapType.MAP:
        url = OpenCycleMapTileProvider.URL_OPEN_CYCLE_MAP;
        break;
      case MapType.SATELLITE:
        url = OpenCycleMapTileProvider.URL_OPEN_CYCLE_MAP2;
        break;
      case MapType.HYBRID:
        url = OpenCycleMapTileProvider.URL_OPEN_CYCLE_MAP3;
        break;
      case MapType.TERRAIN:
        url = OpenCycleMapTileProvider.URL_OPEN_CYCLE_MAP4;
        break;
    }
    return url;
  }

  getUrl(x, y, zoom, mapType?: MapType): string {
    return this.getUrlTemplate(mapType)
      .replace('{z}', zoom)
      .replace('{x}', x)
      .replace('{y}', y);
  }

}
